import { actionTypes } from '@/core/constants'
import DocumentosUrlBuilder from '@/core/utils/factory/documentos/DocumentosUrlBuilder'
import DocumentoEditorTextoApiClient from '@/core/apiclient/documentos/editor-texto/DocumentoEditorTextoApiClient'

function getApiClient(obj) {
	const urlBuilder = new DocumentosUrlBuilder(obj.tipo)
	return new DocumentoEditorTextoApiClient(urlBuilder)
}

export default {
	async [actionTypes.DOCUMENTOS.EDITOR_TEXTO.INSERIR_GENERICO](context, documetoEditorTexto) {
		let apiClient = getApiClient(documetoEditorTexto)
		let { data } = await apiClient.inserir(documetoEditorTexto.model)
		return data
	},

	async [actionTypes.DOCUMENTOS.EDITOR_TEXTO.REDIGIR_GENERICO](context, objRedigir) {
		let apiClient = getApiClient(objRedigir)
		let { data } = await apiClient.redigir(objRedigir.idDocumento)
		return data
	},

	async [actionTypes.DOCUMENTOS.EDITOR_TEXTO.VISUALIZA_GENERICO](context, objVisualizar) {
		let apiClient = getApiClient(objVisualizar)
		let { data } = await apiClient.visualizar(objVisualizar.idDocumento)
		return data
	},

	async [actionTypes.DOCUMENTOS.EDITOR_TEXTO.CONCLUIR_DOCUMENTO_GENERICO](context, objConcluir) {
		let apiClient = getApiClient(objConcluir)
		let { data } = await apiClient.concluirDocumento(objConcluir.idDocumento)
		return data
	},

	async [actionTypes.DOCUMENTOS.EDITOR_TEXTO.BUSCAR_POR_ID](context, objBuscar) {
		let apiClient = getApiClient(objBuscar)
		let { data } = await apiClient.buscarPorId(objBuscar.documento)
		return data
	},

	async [actionTypes.DOCUMENTOS.EDITOR_TEXTO.SINCRONIZAR](context, objSincronizar) {
		let apiClient = getApiClient(objSincronizar)
		let { data } = await apiClient.sincronizarDocumento(objSincronizar.documento)
		return data
	},
}
